var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-edit-user',{attrs:{"isEdit":true,"userId":this.$route.params.userId,"cancelRoute":'User'}})
}
var staticRenderFns = []

export { render, staticRenderFns }